module.exports = __webpack_public_path__ + "static/media/books.94dc5696.jpg";